import { render, staticRenderFns } from "./writecard.vue?vue&type=template&id=5b97d068&scoped=true"
import script from "./writecard.vue?vue&type=script&lang=js"
export * from "./writecard.vue?vue&type=script&lang=js"
import style0 from "./writecard.vue?vue&type=style&index=0&id=5b97d068&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_35e1b9026555e837868613c3c720eb09/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b97d068",
  null
  
)

export default component.exports